<!--高级模板-设置变量-->
<template>
  <!--创建合同-->
  <el-container class="to-create">
    <!--左侧-->
    <el-aside width="2.80rem" class="aside-left" :style="{ height: boxHeight }">
      <p class="page-total">
        共{{ contractInfo.items }}页
        <a
          href="javascript: void(0)"
          @click="
            apiMethods.FileOperController.download_down({
              targetId: contractInfo.contractId,
              fileType: fileType,
              sign: contractInfo.sign,
              ts: contractInfo.ts,
              fix: '.pdf',
            })
          "
          class="fr color-success cred"
          >下载</a
        >
      </p>
      <div class="page-con">
        <template v-for="(i,index) in contractInfo.items">
          <div
            @click="getContractDetailByNum(i)"
            :key="index"
            :class="currentInfo.page === i ? 'active' : ''"
            class="list"
          >
            <img v-if="contractList[i]" :src="contractList[i].url" />
            <img v-else src="/images/contr_default.jpg" alt="" />
            <span>{{ i }}</span>
          </div>
        </template>
      </div>
      <div class="go-Page">
        <div>
          <div>
            <div class="bd">
              <el-input
                v-model="goPageNum"
                placeholder="输入页码"
                type="number"
                @keyup.enter.native="handleContractPageClick"
              />
              /{{ contractInfo.items }}
            </div>
            <a @click="handleContractPageClick">GO</a>
          </div>
        </div>
      </div>
    </el-aside>
    <!--合同显示详情-->
    <el-main class="main-content" :style="{ height: boxHeight }">
      <contract-view
        ref="contractView"
        :contract-info.sync="currentInfo"
        :page="currentInfo.page"
        :items="contractInfo.items"
        :scaleValue.sync="scaleValue"
        :chapter-list.sync="chapteList"
        @pre-page="getContractDetailByNum($event)"
        @next-page="getContractDetailByNum($event)"
        @toCurrentPage="toCurrentPage"
      />
      <!--添加附件-->
      <div ref="accessory" class="text-center accessory-box">
        <!-- 去顶部去底部按钮-->
        <template
          v-if="contractInfo && contractInfo.items && contractInfo.items > 1"
        >
          <span class="jumpFirst" @click="goPageAndFixed(1)"
            ><img src="../../assets/images/btn-down.png"
          /></span>
          <span class="jumpLast" @click="goPageAndFixed(contractInfo.items)"
            ><img src="../../assets/images/btn-down.png"
          /></span>
        </template>
        <div
          @click="accessoryShow = !accessoryShow"
          class="text-center btn"
          ref="step4"
        >
          <i class="el-icon-circle-plus"></i>
          附属材料<i v-if="accessoryShow" class="el-icon-arrow-down arrow"></i>
          <i v-else class="el-icon-arrow-up arrow"></i>
        </div>
        <ul class="text-left accessory-list" id="accessoryList">
          <span
            style="
              position: absolute;
              top: 10px;
              left: 15px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 12px;
            "
            ><img
              style="
                width: 8px;
                height: 8px;
                margin-right: 3px;
                vertical-align: middle;
              "
              src="../../assets/images/x-icon.png"
            />仅供参与方查阅，不用于签署</span
          >
          <li class="accessory-group">
            <template v-if="enclosureFiles.length">
              <p v-for="(item, i) in enclosureFiles" class="list-item" :key="i">
                <span>{{ item.fileName }}</span>
                <i
                  @click="delAttatchFileNamesJson(item, i)"
                  class="el-icon-error del"
                ></i>
              </p>
            </template>
            <div class="title upload-accessory">
              <!--              <a href="javascript:void (0)" class="color-success"><img class="up-icon" src="../../assets/images/up-icon.png"/>上传附属文件</a>-->
              <div class="div-upload">+</div>
              <input
                class="input-upload"
                @change="handleAttatchFileUpload"
                type="file"
                name="attatchInput"
              />
            </div>
          </li>
        </ul>
      </div>
    </el-main>
    <!--右侧-->
    <el-aside
      width="2.80rem"
      class="aside-right"
      :style="{ height: boxHeight }"
    >
      <div style="height: 100%; overflow-x: hidden; overflow-y: auto">
        <div class="tp-box">
          <template>
            <p
              :class="{
                spec: true,
                'm-title': true,
              }"
            >
                <!-- choose: tplUsePerson === 'addKJ', -->
              <span class="t-span">1</span>
              <span :class="{ st1: true }" @click="setTplVar">设置模板变量</span>
              <el-tooltip effect="light" placement="bottom-end">
                <div slot="content">
                  <p>1. 设置模板变量后，使用模板时需填写设置的变量</p>
                  <p>2. 复制：在文档中其它地方需要使用该变量时，点击复制并拖拽到需要使用的位置。</p>
                  <p>3. 红色(初始的)变量可编辑，绿色(复制的)不可编辑</p>
                </div>
                <i
                  class="el-icon-question"
                  style="
                    font-size: 16px;
                    margin:0 10px;
                    color: #a1a1a1;
                    cursor: pointer;
                  "
                ></i>
              </el-tooltip>
            </p>
            <div class="bc-box">
              <div class="flex-box" style="padding-top: 10px">
                <template v-for="(item, i) in [...baseComponents,...formatComponents]">
                  <div
                    v-if="!$route.query.apiPdf || (item.flag !== flag.SYSTEMDATE)"
                    :key="i"
                    class="drop-one"
                    draggable="true"
                    @dragstart="dragQZStart($event, {flag:item.flag})"
                    @dragend="dragQZEnd($event, {flag:item.flag})"
                  >
                  <!-- v-if="![-1, 0].includes(item.flag)" -->
                    <span :class="item.icon"></span>
                    <p>{{ item.text }}</p>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-if="!APITPL">
<!--            <p class="m-title" style="margin-top: 0.25rem">-->
<!--            <span class="t-span">2</span>选择签署方-->
<!--              <el-tooltip effect="light" content="" placement="bottom-end">-->
<!--                <div slot="content">-->
<!--                  给每个签署方设置签署位置后，签署方将在指定位置签署-->
<!--                </div>-->
<!--                <i-->
<!--                  class="el-icon-question"-->
<!--                  style="-->
<!--                    font-size: 16px;-->
<!--                    margin-left: 10px;-->
<!--                    color: #a1a1a1;-->
<!--                    cursor: pointer;-->
<!--                  "-->
<!--                ></i>-->
<!--              </el-tooltip>-->
<!--            </p>-->
<!--            <el-radio-group v-model="tplUsePerson">-->
<!--              <template-->
<!--                v-for="(item, index) in GET_addTpl_contractInfoJson.signers"-->
<!--              >-->
<!--                &lt;!&ndash;未定&ndash;&gt;-->
<!--                <el-radio-->
<!--                  v-if="item.fix == 0"-->
<!--                  :key="index"-->
<!--                  :label="item.signerAbc"-->
<!--                  :title="item.signerAbc"-->
<!--                  @click.native="selectSigner = item"-->
<!--                  >-->
<!--  &lt;!&ndash;                <span>未定</span>&ndash;&gt;-->
<!--                  {{ item.signerAbc }}-->
<!--                </el-radio>-->
<!--                <template v-else>-->
<!--                  &lt;!&ndash;个人&ndash;&gt;-->
<!--                  <el-radio-->
<!--                    v-if="item.userType == 0"-->
<!--                    :key="index"-->
<!--                    :label="item.signerAbc"-->
<!--                    :title="item.name"-->
<!--                    @click.native="selectSigner = item"-->
<!--                    >-->
<!--  &lt;!&ndash;                  <span>个人</span>&ndash;&gt;-->
<!--                    {{ item.name }}-->
<!--                  </el-radio>-->
<!--                  &lt;!&ndash;企业&ndash;&gt;-->
<!--                  <el-radio-->
<!--                    v-if="item.userType == 1"-->
<!--                    :key="index"-->
<!--                    :label="item.signerAbc"-->
<!--                    :title="item.name"-->
<!--                    @click.native="selectSigner = item"-->
<!--                    >-->
<!--  &lt;!&ndash;                  <span>企业</span>&ndash;&gt;-->
<!--                    {{ item.name }}-->
<!--                  </el-radio>-->
<!--                </template>-->
<!--              </template>-->
<!--            </el-radio-group>-->
            <!--      拖动签署位置    -->
            <div>
              <p class="m-title" style="margin-top: 0.25rem" >
                <span class="t-span">2</span>拖动签署位置
              </p>
<!--               v-if="tplUsePerson !== 'addKJ'"-->
              <div class="bc-box">
                <div>
                  <div v-for="(signerItem, index) in GET_addTpl_contractInfoJson.signers" :key="index">
                    <!--0 模板发起人指定-->
                    <template v-if="signerItem.fix == 0">
                      <!--未指定-盖章或者签字-->
                      <div
                        class="drop-one signer_drop"
                        draggable="true"
                        @dragstart="dragQZStart($event, {flag:flag.SIGNNATUREANDSIGN, selectSigner: signerItem})"
                        @dragend="dragQZEnd($event, {flag:flag.SIGNNATUREANDSIGN})"
                      >
                        <span class="icon-qzgz"></span>
                        <div class="signer_name">{{ signerItem.signerAbc }}签署位置</div>
                      </div>
                    </template>
                    <template v-else>
                      <!--个人签字-->
                      <div
                        v-if="signerItem.userType == 0"
                        class="drop-one signer_drop"
                        draggable="true"
                        @dragstart="dragQZStart($event, {flag:flag.SIGN, selectSigner: signerItem})"
                        @dragend="dragQZEnd($event, {flag:flag.SIGN})"
                      >
                        <span class="icon-qz"></span>
                        <div class="signer_name">{{signerItem.name}}签署位置</div>
                      </div>
                      <!--企业盖章-->
                      <div
                        v-if="signerItem.userType == 1"
                        class="drop-one signer_drop"
                        draggable="true"
                        @dragstart="dragQZStart($event, {flag:flag.SIGNNATURE, selectSigner: signerItem})"
                        @dragend="dragQZEnd($event, {flag:flag.SIGNNATURE})"
                      >
                        <span class="icon-gz"></span>
                        <div class="signer_name">{{signerItem.name}}签署位置</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- 已复制变量 -->
            <div v-if="copiedAdd.length">
              <p class="copy-title" >
                <img src="/images/icon/copy_icon.png" alt="已复制的变量">
                已复制的变量
              </p>
              <div class="bc-box">
                  <div v-for="item of copiedAdd" :key="item.copyCindex" class="pointer" draggable="true"
                  @dragstart="dragQZStart($event, {flag:item.varType,varInfo:item})"
                  @dragend="dragQZEnd($event, {flag:item.varType})">
                    <div class="bc-item">
                      <span class="item-sty">
                        <span class="icon-sty" :class="varIcon(item.varType)"></span>
                        &nbsp;&nbsp;{{`${
                        [flag.SIGNNATURE,flag.SIGN,flag.SIGNNATUREANDSIGN,].includes(item.varType) ? item.signerAbc : item.inputId
                        }（${chapteList.filter(kk=>(kk.copy && kk.copyCindex === item.copyCindex)).length} 个）`
                        }}
                        </span>
                      <i class="el-icon-circle-close pointer" @click="delCopy(item)"></i>
                    </div>
                    <el-divider></el-divider>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <!--新增模板-->
      <div class="bb-box" v-if="!$route.query.id">
        <el-button @click="publishTpl" type="danger" class="danger-btn"
          >立即发布</el-button
        >
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 0.15rem;
          "
        >
           <el-button @click="preStep" class="default-btn">上一步</el-button>
<!--   <el-button @click="saveToDraft" class="default-btn"-->
<!--     >存为草稿</el-button-->
<!--          >-->
        </div>
      </div>
      <template v-if="$route.query.id">
        <!--1草稿，2启用，3停用，4删除-->
        <!--编辑草稿状态模板-->
        <div class="bb-box" v-if="+GET_addTpl_tplData.status === 1">
          <el-button @click="submitConfirmCG" type="danger" class="danger-btn"
            >确认提交</el-button
          >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 0.15rem;
            "
          >
             <el-button @click="preStep" class="default-btn">上一步</el-button>
<!--            <el-button @click="saveToDraft" class="default-btn"-->
<!--              >存为草稿</el-button-->
<!--            >-->
          </div>
        </div>
        <!--编辑模板-->
        <div class="bb-box" v-else>
          <el-button @click="submitConfirm" type="danger" class="danger-btn"
            >确认提交</el-button
          >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 0.15rem;
            "
          >
            <el-button @click="preStep" class="default-btn" style="width: 100%;"
              >上一步</el-button
            >
          </div>
        </div>
      </template>
    </el-aside>

    <!--弹窗-->
    <el-dialog
      title="提示"
      class="com-myDialog"
      :visible.sync="tipsDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="con">
        <p style="margin-top: 40px">
          <span class="el-icon-warning"></span>当前内容还未保存，确认退出编辑？
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="(tipsDialogVisible = false), (sureEdit = false)"
          >继续填写</el-button
        >
        <el-button type="primary" @click="confirmEdit">仍然退出</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="模板发起成功"
      class="com-myDialog"
      :visible.sync="fqDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="con">
        <h1
          style="
            font-weight: normal;
            margin-top: 30px;
            text-align: left;
            font-size: 16px;
            box-sizing: border-box;
            padding-left: 28px;
          "
        >
          <span class="el-icon-success"></span>模板发起成功
        </h1>
        <p style="font-size: 14px; color: rgba(41, 2, 2, 0.65)">
          当前模板为停用状态，启用后授权人才可使用该模板！
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- @click="
            () => {
              (fqDialogVisible = false),
                $router.push({
                  path: '/console/setting',
                  query: { activeName: 'tab-template' }
                });
            }
          " -->
        <el-button
          style="width: 94px"
          @click="
            () => {
              (fqDialogVisible = false),
                $router.push({
                  path: '/console/template',
                });
            }
          "
        >
          返回模板管理
        </el-button>
        <el-button
          style="width: 94px"
          type="primary"
          @click="fqDialogVisible = false"
          >立即启用</el-button
        >
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import md5 from "js-md5";
import {mapGetters} from "vuex";
import Flow from "../../components/flow";
import draggable from "vuedraggable";
import SingerForm from "../../components/singer-form";
import ToolTip from "../../components/tool-tip";
import ContractView from "../../components/advancedVersion/contractView";
import {
  convertDetailToShow,
  postFileTempUpload2,
  tempConvertToContract,
  ApiMethods,
} from "../../assets/js/http-serve/http-methods";
import flagType from "../../components/advancedVersion/flagType";
import { formatParam, formatComponents } from "./advancedVersion";

const flag = flagType.flag;

export default {
  components: { ContractView, ToolTip, SingerForm, draggable, Flow },
  data () {
    return {
      showVAR: false, // 展示变量
      flag,
      apiMethods: ApiMethods,
      boxHeight: "1170px",
      goPageNum: null, // 前往多少页
      // ..............右侧组件相关...........
      flagType: flagType,
      // 基础控件
      baseComponents: [
        // {
        //   text: "单行文本",
        //   flag: flag.TEXT,
        //   icon: "icon-txt1"
        // },
        // {
        //   text: "多行文本",
        //   flag: flag.MULTITEXT,
        //   icon: "icon-txt2"
        // },
        {
          text: "数字",
          flag: flag.NUMBER,
          icon: "icon-number"
        }
      ],
      // 格式控件
      formatComponents,
      // 默认控件
      qzComponents: [
        {
          text: "签署位置（企业）",
          flag: flag.SIGNNATURE,
          icon: "icon-gz"
        },
        {
          text: "签署位置（个人）",
          flag: flag.SIGN,
          icon: "icon-qz"
        },
        // {
        //   text: "签署位置",
        //   flag: flag.SIGNNATUREANDSIGN,
        //   icon: "icon-qzgz"
        // }
      ],
      // .............附件相关.............
      accessoryShow: false,
      timer: null,
      // 附件
      enclosureFiles: [],
      // .............合同相关.............
      // 合同信息查看相关变量
      contractInfo: {
        items: 0,
        ts: null,
        sign: null,
        docHash: null,
        contractId: null,
        contractName: ""
      },
      // 合同列表
      contractList: [],
      // 合同的签章列表 {offsetX: '0.5', offsetY: '0.5', cindex: 0章顺序不分甲乙方和页数, signOwner: 甲乙方, url: 章地址， page: 0合同页数}
      chapteList: [],
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      // 合同缩放比例
      scaleValue: 100,

      // .............页面右侧部分变量.............
      tplUsePerson: "addKJ",
      // 弹窗
      fqDialogVisible: false,
      // 离开页面是否修改的判断
      tipsDialogVisible: false,
      highAuthorityPath: ["/advancedVersion/addTpl"], // 不需要判断可以直接跳转的路由
      sureEdit: false,
      toPath: "", // 拦截前用户想要前往的页面
      // 合同是否更改判断
      inputsRecord: "",
      // 当前选中的签署方
      selectSigner: {}
    };
  },
  created(){
    if(!this.$route.query.apiPdf){
      // 如果非pdf模板文件，过滤出签章变量
      this.formatComponents = formatComponents.filter(v=> !([flag.SIGNNATURE,flag.SIGN].includes(v.flag)))
    }
  },
  mounted () {
    if (
      !this.GET_addTpl_contractInfoJson ||
      JSON.stringify(this.GET_addTpl_contractInfoJson) === "{}"
    ) {
      // 验证数据是否存在
      this.sureEdit = true;
      const { userType } = this.$route.query;
      // userType  0 个人
      this.$router.replace({
        path: userType == 0 ? "/tpl/add/addTpl" : "/advancedVersion/addTpl",
        query: { ...this.$route.query }
      });
      return false;
    } else {
      if (this.GET_addTpl_recordContract) {
        this.inputsRecord = md5(
          JSON.stringify(this.GET_addTpl_recordContract.inputGroups[0].inputs)
        ); // 记录之前的组件值
      }
      //默认勾选
      const SIGNERS = this.GET_addTpl_contractInfoJson.signers[0]
      this.selectSigner = SIGNERS ? SIGNERS : {};
      if(SIGNERS) this.tplUsePerson = SIGNERS.signerAbc;
      let chapteList = []; // 回显组件
      try {
        const list = this.GET_addTpl_contractInfoJson.inputGroups[0].inputs;
        chapteList = list.map((chap,i) => {
          chap.cindex = i + "-" + new Date().getTime();
          chap.bold = chap.bold ? chap.bold : "";
          chap.align = chap.align ? chap.align : "";
          return chap
        });
      } catch (err) {
        console.log('catch_捕获：',err);
      }
      // 这里这么写是加入的有复制（引用）变量，引用变量的【copyCindex】使用源变量的【cindex】
      const copyChap = chapteList.filter((item)=> item.copy)
      const sourChap = chapteList.filter((item)=> !item.copy)
      const _sourChap = sourChap.map((item, inx) => {
        let findSigners = this.GET_addTpl_contractInfoJson.signers.find(
          sub => sub.signerAbc === item.signerAbc
        ); // 找到该签章对应的签署人
        const _chap={
          ...item,
          // 构造辅助变量
          qsInfo: findSigners ? findSigners.name : "", // 在签章上显示签署方的信息
          showSetting: !!item.showSetting, // 默认不显示
        };
        return _chap
      });
      const _copyChap = copyChap.map((item, inx) => {
        let findSigners = this.GET_addTpl_contractInfoJson.signers.find(
          sub => sub.signerAbc === item.signerAbc
        ); // 找到该签章对应的签署人
        const _copy={
          ...item,
          // 构造辅助变量
          qsInfo: findSigners ? findSigners.name : "", // 在签章上显示签署方的信息
          showSetting: !!item.showSetting, // 默认不显示
        };
        const sour = _sourChap.filter(s=> s.inputId === item.inputId)
        if(sour.length) {
          _copy.copyCindex = sour[0].cindex;
          // 这里将创建时记录的值重新对齐目标签章
          if(_copy.batch){ _copy.batch = sour[0].cindex}
        }
        return _copy
      });
      this.chapteList = [..._sourChap,..._copyChap]
      // console.log('this.chapteList',this.chapteList);

      this.enclosureFiles = this.GET_addTpl_contractInfoJson.files.filter(
        item => +item.tplFileType === 2
      ); // 1合同，2附件
    }

    this.boxHeight = document.body.clientHeight - 60 + "px";

    let contract = this.getContractInfo(); // 合同文件
    let fl = contract.storeFile ? contract.storeFile : contract.tempFile;
    this.convertContractToInfo({
      fileName: contract.fileName,
      targetId: fl.targetId,
      fileType: fl.fileType,
      sign: fl.sign,
      ts: fl.ts,
      docHash: fl.docHash
    });

    window.addEventListener("beforeunload", this.leavePage);
  },
  beforeDestroy (next) {
    this.timer && clearInterval(this.timer);
    window.removeEventListener("beforeunload", this.leavePage);
  },
  watch: {
    accessoryShow (val) {
      clearInterval(this.timer);
      let fileHeight = document.getElementById("accessoryList").clientHeight;
      if (val) {
        let top = -fileHeight;
        this.timer = setInterval(() => {
          if (top === 0) {
            return clearInterval(this.timer);
          }
          top += 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      } else {
        let top = 0;
        this.timer = setInterval(() => {
          if (top === -fileHeight) {
            return clearInterval(this.timer);
          }
          top -= 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      }
    }
  },
  computed: {
    // 获取store里面的数据
    ...mapGetters("advancedVersionState", {
      GET_addTpl_tplData: "GET_addTpl_tplData",
      GET_addTpl_recordContract: "GET_addTpl_recordContract",
      GET_addTpl_contractInfoJson: "GET_addTpl_contractInfoJson"
    }),
    APITPL(){
      const {apiPdf} = this.$route.query
      return apiPdf ? true : false
    },
    /** 将复制变量放入数组 */
    copiedAdd(){
      const _chapList = this.chapteList.filter(item=>!item.copy)
      const _copyChap = this.chapteList.filter(item=>item.copy)
      // console.log('_copyChap',_copyChap);
      if(_copyChap.length){
        const uniqueArr = this.uniqueByKey(_copyChap,'copyCindex');
        // console.log('uniqueArr',uniqueArr);
        // console.log('this.chapteList',this.chapteList);
        return uniqueArr
      }else{
        return []
      }

      // const repeat = this.copiedVariables.filter(elem=> elem.cindex === item.cindex)
      // if(repeat.length) return
      // this.copiedVariables.push(item)
    },
  },
  // 页面路由更改时
  beforeRouteLeave (to, from, next) {
    if (this.canLeave(to.path)) {
      this.toPath = to.fullPath;
      this.tipsDialogVisible = true;
      next(false);
    } else {
      next(true);
    }
  },
  methods: {
    /** 对象数组去重 */
    uniqueByKey(arr, key) {
      const seen = new Set();
      return arr.filter((item) => {
        const serializedKey = JSON.stringify(item[key]);
        if (!seen.has(serializedKey)) {
          seen.add(serializedKey);
          return true;
        }
        return false;
      });
    },
    /** 返回变量icon */
    varIcon(varType){
      const elem = [...this.baseComponents,...this.formatComponents].filter(item=>item.flag == varType);
      return elem[0] ? elem[0].icon : '';
    },
    /** 删除复制变量 */
    delCopy(item){
      this.$confirm(
        `是否删除 ${item.inputId} 的 ${this.chapteList.filter(kk=>(kk.copy && kk.copyCindex === item.copyCindex)).length} 个复制变量？`,
        "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
          .then(() => { this.chapteList = this.chapteList.filter(chap=> chap.copyCindex !== item.copyCindex)})
          .catch(() => { });
    },
    //
    setTplVar () {
      this.selectSigner = {};
      this.tplUsePerson = "addKJ";
    },
    // ......离开页面判断 start.....
    // 刷新或者关闭页面时提示
    leavePage (e) {
      if (this.canLeave()) {
        let dialogText = "当前内容还未保存，确认退出编辑？"; // 大部分浏览器使用默认文案，这将不生效
        e = e || window.event;
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = dialogText;
        }
        // For Safari
        return dialogText;
      }
    },
    confirmEdit () {
      this.tipsDialogVisible = false;
      this.sureEdit = true;
      this.$router.push({ path: this.toPath });
    },
    /**
     * 是否可以离开页面
     * @toPath 页面要前往的地址
     * */
    canLeave (toPath) {
      return (
        this.highAuthorityPath.indexOf(toPath) === -1 &&
        !this.sureEdit &&
        this.IsPageChange()
      );
    },
    // 页面内容是否更改
    IsPageChange () {
      if (
        md5(JSON.stringify(this.GET_addTpl_recordContract)) !==
        md5(JSON.stringify(this.savedContractInfo()))
      ) {
        // 数据有更改
        return true;
      }
      return false;
    },
    /**
     * 用于存储比较用的setAddTplRecordContract信息,初次新增或者初次编辑时存储,过滤出必要的参数信息
     * 使用场景:离开页面时判断页面是否修改
     * */
    savedContractInfo () {
      let confo = this.GET_addTpl_contractInfoJson;
      let info = formatParam({
        tplId: confo.tplId || null,
        tplName: confo.tplName,
        orderFlag: confo.orderFlag,
        inputGroups: [{ title: "", inputs: JSON.parse(JSON.stringify(this.chapteList)) }],
        signers: confo.signers,
        // 文件上传信息
        files: [this.getContractInfo(), ...this.enclosureFiles],
        groupIdSet: confo.groupIdSet || [] // 授权多个部门 id
      });
      return info;
    },
    // ......离开页面判断 end.....

    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 业务逻辑
    /**
     *  获取之前上传的合同文件
     * */
    getContractInfo () {
      return this.GET_addTpl_contractInfoJson.files.find(
        item => +item.tplFileType === 1
      ); // 1合同，2附件
    },
    // 查询合同页数等信息
    convertContractToInfo (param) {
      this.loadingStart("正在加载合同信息");

      tempConvertToContract(param)
        .then(({ data }) => {
          this.loadingClose();

          let tempFile = data.tempFile || {
            ts: param.ts,
            sign: param.sign,
            targetId: param.targetId,
            fileType: param.fileType
          };
          this.contractInfo.docHash = data.docHash;
          this.contractInfo.ts = tempFile.ts;
          this.contractInfo.sign = tempFile.sign;
          this.contractInfo.items = parseInt(data.items);
          this.contractInfo.contractId = tempFile.targetId;
          this.contractInfo.contractName = param.contractName;
          this.currentInfo = { page: 1, url: "" };
          this.fileType = tempFile.fileType || 1;

          this.getContractDetailByNum(1);
        })
        .catch(err => {
          this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        });
    },

    // 输入input合同跳页
    handleContractPageClick () {
      let page = this.goPageNum;
      page = parseFloat(page);
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.contractInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.goPageAndFixed(page);
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed (page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage (val) {
      let dom = document.querySelectorAll(".page-con .list")[val - 1];
      if (dom) {
        document.querySelectorAll(".page-con")[0].scrollTop = dom.offsetTop;
      }
    },
    // 按页数获取合同
    getContractDetailByNum (num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }

      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          sign: this.contractInfo.sign,
          ts: this.contractInfo.ts,
          fileType: this.fileType,
          fix: "png",
          targetId: this.contractInfo.contractId,
          num: num - 1,
          docHash: this.contractInfo.docHash
        })
      };

      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },

    // 。。。。。。。。。。。。。。附件相关。。。。。。。。。。。。。。
    // 删除附件
    delAttatchFileNamesJson (attatch, index) {
      this.enclosureFiles &&
        this.enclosureFiles.length &&
        this.enclosureFiles.splice(index, 1);
    },
    // 上传附件
    handleAttatchFileUpload (el) {
      if (this.enclosureFiles.length >= 3) {
        this.$message.error("附件最多只能上传3个");
        return (el.target.value = "");
      }
      el = el.target;
      let file = el.files[0] || null;
      if (!file) return false;
      if (file.size > 30 * 1024 * 1024) {
        this.$message.warning("附件大小不能超过30M!");
        return;
      }
      this.loadingStart("正在上传附件");
      postFileTempUpload2({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          console.log("上传附件：", data);
          el.value = "";

          this.enclosureFiles.push({
            fileName: file.name,
            tplFileType: 2, // 文件类型：1合同文件 2附件
            tempFile: {
              // 文件上传信息
              fileType: data.fileType,
              sign: data.sign,
              targetId: data.targetId,
              ts: data.ts
            },
            // 前端辅助变量-文件大小
            size: file.size
          });
        })
        .catch(err => {
          this.loadingClose();
          el.value = "";
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },

    //。。。。。。。。。。。。。。。右侧相关 start。。。。。。。。。。。。。
    dragQZStart (ev, obj) {
      const {flag,varInfo} = obj
      const isSign = [
        this.flag.SIGNNATUREANDSIGN,
        this.flag.SIGN,
        this.flag.SIGNNATURE
      ].includes(flag);
      if (!isSign) this.setTplVar();
      const data = {
          flag,
          selectSigner:  obj.selectSigner
        }
      if(varInfo) data.varInfo = varInfo
      console.log('vat_data',data);
      ev.dataTransfer.setData(
        "addZj",
        JSON.stringify(data)
      );
    },
    dragQZEnd (ev, flag) { },
    /**
     * WEB模版保存更新,修改
     * @status 状态  1草稿：默认草稿状态，2启用：需要再调用设置状态的接口，将当前模板设置为启用
     * */
    async saveTplData (status) {
      // this.loadingStart("模板生成中...");
      this.sureEdit = true;
      let param = await this.savedContractInfo();
      // userType 0 个人（1197需求 个人也加入了文件上传创建模板）
      const { userType,apiPdf } = this.$route.query;
      const APITAMPLATE_API=ApiMethods.TemplateController.advanceVOperTplAPI,WEBAPI = userType && userType == 0
          ? ApiMethods.TemplateController.versionOperTpl
          : ApiMethods.TemplateController.advanceVOperTpl;
      // 存在 apiPdf 是添加API模板 否则 添加web模板
      const apiCustom = apiPdf ? APITAMPLATE_API : WEBAPI
      apiCustom(param).then(result => {
        if (result.success) {
          if (param.tplId) {
            // 编辑模板时，默认保存为之前的状态
            if (+status === 2) {
              // 将草稿模板设置为启用
              this.setTplStatus(param.tplId, 2); // 启用当前模板
            } else {
              this.$message.success("模板更新成功");
              this.savedAndLeave();
            }
          } else {
            // 新增模板
            switch (+status) {
              case 1: // 保存草稿弹窗
                this.$message.success("保存成功");
                this.savedAndLeave();
                break;
              case 2: // 启用
                if (userType == 0) {
                  this.$message.success("保存成功");
                  this.savedAndLeave();
                  return;
                }
                this.setTplStatus(result.data, 2); // 启用当前模板
                break;
            }
          }
        } else {
          this.$message.error(result.description || this.$tip);
        }
      }).finally(()=>{this.loadingClose()});
    },
    // 更改模板状态-新增时保存默认是草稿状态，需要设置为启用
    setTplStatus (tplId, status) {
      const {apiPdf} = this.$route.query
      // api模板不调用
      if(apiPdf) {
        this.$message.success("发布成功");
        this.savedAndLeave();
        return
      }
      ApiMethods.TemplateController.advanceVSetStatus({ tplId, status }).then(
        result => {
          if (result.success) {
            // this.$message.success("发布成功");
            // this.savedAndLeave();
            // 1197
            this.$confirm(
              "模板创建成功！是否立即授权给组织成员使用？",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            )
              .then(() => {
                // 点击确定
                ApiMethods.TemplateController.allowMemberUseTem({
                  tplId,
                  tplVersion: 2
                }).then(res => {
                  if (!res.success) {
                    this.$message.error(`${res.description},请手动开启授权！`);
                  }
                  // 授权给组织使用后跳页面
                  this.savedAndLeave();
                });
              })
              .catch(() => {
                // 点击取消
                this.savedAndLeave();
              });
          } else {
            this.$message.error(result.description || this.$tip);
          }
        }
      );
    },
    // 保存成功并跳转
    savedAndLeave () {
      this.loadingClose();
      this.$store.dispatch("advancedVersionState/clearAddTpl").then(() => {
        // this.$router.push({path: '/console/setting', query: {activeName: 'tab-template'}})
        const { userType } = this.$route.query;
        const usrBool = userType && userType == 0;
        this.$router.push({
          path: usrBool ? "/tpl/general" : "/console/template",
          query: usrBool ? {} : { activeName: "mianSign" }
        });
      });
    },
    preStepFn() {
      this.$router.back();
    },
    // 上一步
    preStep () {
      // 获取合同信息-原样保存
      let infoContract = this.getContractInfo(); // 1合同，2附件

      // 存储组件信息,附件信息
      this.$store.commit(
        "advancedVersionState/SET_addTpl_contractInfoJsonAttribute",
        {
          inputGroups: [{ title: "", inputs: this.chapteList }],
          files: [infoContract, ...this.enclosureFiles]
        }
      );

      // this.sureEdit = true
      this.$router.go(-1)
      // this.$router.push({
      //   path: "/advancedVersion/addTpl",
      //   query: { ...this.$route.query }
      // });
    },
    // 签章位置是否设置
    qzIsSetting (callback) {
      const {apiPdf} = this.$route.query
      if (apiPdf) {
        callback && callback();
        return
      }
      let signersCopy = JSON.parse(
        JSON.stringify(this.GET_addTpl_contractInfoJson.signers)
      );
      let inputs = this.chapteList;
      this.GET_addTpl_contractInfoJson.signers.map((item, index) => {
        if (inputs.find(sub => sub.signerAbc === item.signerAbc && sub.varType !== 10)) {
          let inx = signersCopy.findIndex(
            svv => svv.signerAbc === item.signerAbc
          );
          signersCopy.splice(inx, 1);
        }
      });
      if (!signersCopy.length) {
        callback && callback();
      } else {
        // 需要设置签章位置
        let str = "";
        signersCopy.map(item => {
          str += (item.name || item.signerAbc) + "，";
        });
        str = str.substring(0, str.length - 1);
        this.$confirm("请给以下签署方指定签署位置：<br/>" + str, "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "warning",
          customClass: "com-confirmDialog sure"
        })
          .then(() => { })
          .catch(() => { });
      }
    },
    // 立即发布
    publishTpl () {
      this.qzIsSetting(() => {
        this.$confirm("是否立即发布？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.saveTplData(2);
          })
          .catch(() => { });
      });
    },

    // 草稿状态的确认提交-需要提交后启用该草稿
    submitConfirmCG () {
      this.qzIsSetting(() => {
        this.$confirm("是否立即提交？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.saveTplData(2);
          })
          .catch(() => { });
      });
    },

    // 确认提交
    submitConfirm () {
      this.qzIsSetting(() => {
        this.$confirm("是否立即提交？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.saveTplData();
          })
          .catch(() => { });
      });
    },
    /**
     *  存为草稿
     * */
    saveToDraft () {
      this.$confirm("确定保存为草稿？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.saveTplData(1);
        })
        .catch(() => { });
    }
    //。。。。。。。。。。。。。。。右侧相关 end。。。。。。。。。。。。。
  },
  layout: "fullpage",
  head: { title: "模板设置" },
  name: "setVariable"
};
</script>

<style lang="less" scoped>
@import (less) "../../assets/style/icon.css";

.font-elips() {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.to-create {
  margin: -20px;
}

@mg: 0.2rem; // 左右side给中间合同流的间距

.aside-left {
  /*padding-top: .20rem;*/
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 3;
  margin-right: @mg;

  .cred {
    color: #ec1c1c;
  }

  .list.active img {
    border-color: #ec1c1c;
  }

  .list.active span {
    background-color: #ec1c1c;
  }

  .list {
    position: relative;
    margin: 0 0.3rem 0.2rem 0.3rem;
    cursor: pointer;

    span {
      position: absolute;
      bottom: 2px;
      right: 0;
      display: block;
      /*width: 20px;*/
      /*height: 20px;*/
      width: 0.4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-radius: 0.06rem 0px 0px 0px;
      color: #fff;
      background-color: #e3e3e3;
      text-align: center;
    }

    img {
      display: block;
      width: 100%;
      /*max-height: 230px !important;*/
      max-height: 3rem !important;
      box-sizing: border-box;
      margin-bottom: 0.1rem;
      border: 2px solid #e3e3e3;
    }
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    padding: 0 0.3rem 0 0.3rem;
    height: 60px;
    line-height: 60px;
  }

  .page-con {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.9rem;
    top: 60px;
    box-sizing: border-box;
    padding-top: 0.2rem;
    border-top: 1px solid #f2f2f2;
  }

  // 跳转页面
  .go-Page {
    // height:60px;
    // line-height:60px;
    padding: 0.3rem 0;
    width: 100%;
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 5;
    background-color: #ffffff;

    > div {
      display: inline-block;

      > div {
        display: flex;
        text-align: center;
        justify-content: space-between;
        align-items: center;
        height: 32px;
        line-height: 28px;
      }
    }

    .bd {
      height: 100%;
      box-sizing: border-box;
      border: 1px solid rgba(183, 183, 183, 1);
      border-style: solid none solid solid;
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      padding-right: 0.05rem;
      border-radius: 0.04rem 0 0 0.04rem;
    }

    a {
      text-decoration: none;
      cursor: pointer;
      box-sizing: border-box;
      width: 0.6rem;
      border-radius: 0px 0.04rem 0.04rem 0.04rem;
      display: block;
      background: #999999;
      border: 1px solid #999999;
      color: rgba(255, 255, 255, 1);
      font-family: PingFang SC;
    }

    /deep/ .el-input {
      /*width: 75px;*/
      width: 1.2rem;
      height: 100%;
    }

    /deep/ .el-input__inner {
      font-size: 0.14rem;
      border: none;
      padding: 0 0 0 0.05rem;
      height: 100%;
      line-height: inherit;
    }
  }
}

.main-content {
  flex: 1;
  position: relative;
  /*display: table-cell;*/
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  /*background: #ffffff;*/
  overflow: hidden;
  z-index: 2;

  .accessory-box {
    position: absolute;
    bottom: -106px;
    width: 100%;
    pointer-events: none;
    z-index: 8;

    .accessory-list {
      pointer-events: initial;
      position: relative;
      width: 100%;
      /*display: flex;*/
      /*justify-content: flex-start;*/
      /*flex-wrap: wrap;*/
      /*align-items: center;*/
      box-sizing: border-box;
      // border-top: 1px solid rgba(0,0,0,0.16);
      padding: 56px 15px 20px 15px;
      background: #ffffff;
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);

      li {
        /*flex: none;*/
        /*display: table-cell;*/
        /*width: 100%;*/
      }

      .accessory-group {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;

        p.list-item {
          display: inline-block;
          position: relative;
          margin: 4px 25px 4px 0;
          padding: 6px 19px 6px 5px;
          // border: 4px;
          font-size: 12px;
          color: #000000;
          background: rgba(248, 248, 248, 1);

          > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }

        i.del {
          color: #a1a1a1;
          position: absolute;
          right: -6px;
          top: -6px;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .upload-accessory {
        /*width: 75px;*/
        overflow: hidden;
        position: relative;
        cursor: pointer;
        display: inline-block;

        &:hover {
          opacity: 0.5;
        }

        a {
          // font-size:16px;
          display: inline-block;
          width: 120px;
          line-height: 35px;
          color: #ec1c1c;
          font-weight: bold;
        }

        &:hover a {
          font-weight: 800;
        }

        /*input {*/
        /*  position: absolute;*/
        /*  width: 300px;*/
        /*  height: 300px;*/
        /*  top: -18px;*/
        /*  left: -73px;*/
        /*  cursor: pointer;*/
        /*  opacity: 0;*/
        /*}*/

        .up-icon {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 5px;
        }

        .div-upload {
          /*cursor: pointer;*/
          border: 1px dashed #ec1c1c;
          width: 80px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          text-align: center;
          color: #ec1c1c;
          font-size: 18px;
          font-weight: normal;
          position: relative;
          z-index: 2;
        }

        .input-upload {
          cursor: pointer;
          position: absolute;
          z-index: 3;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
        }
      }
    }

    div.btn {
      pointer-events: initial;
      display: inline-block;
      // width: 120px;
      // height: 35px;
      // line-height: 35px;
      padding: 0 10px;
      font-size: 14px;
      // color: #ffffff;
      // background: #a2a5ac;
      // border-radius: 3px 3px 0 0;
      cursor: pointer;
      width: 150px;
      height: 45px;
      line-height: 45px;
      background: rgba(255, 255, 255, 0.65);
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);
      border-radius: 6px 6px 0px 0px;
      color: #ec1c1c;
      font-size: 15px;
      font-weight: bold;

      .arrow {
        margin-left: 15px;
        font-size: 12px;
        font-weight: bold;
        vertical-align: middle;
        display: inline-block;
        margin-top: -2px;
      }
    }
  }
}

.aside-right {
  color: #290202;
  box-sizing: border-box;
  // padding: 20px 20px 0 20px;
  background-color: #ffffff;
  overflow: hidden;
  position: relative;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  z-index: 3;
  margin-left: @mg;
  padding-bottom: 1.7rem;

  .t2 {
    /*color: #000000;*/
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
  }

  .t3 {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    padding-left: 0.3rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
    font-size: 12px;
  }
  .text-tip {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    > i {
      margin: 0 10px;
    }
    .text {
      padding: 0 5px;
      border: 1px solid #ec1c1c;
      background-color: #fef3f3;
      color: #7f7f7f;
    }
  }
  .m-title {
    .t2();
    position: relative;
    margin-bottom: 0.15rem;
    padding-left: 0.32rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: start;

    .el-icon-question {
      margin-top: 0.02rem;
    }
  }
  .copy-title{
    .t2();
    margin-top: 0.25rem;
    display: flex;
    justify-content: start;
    margin-bottom: 0.15rem;
    >img{
      width: 25px;
      margin-right: 10px;
    }
  }

  .spec {
    line-height: 0.35rem;
    display: flex;
    align-items: center;
    .t-span {
      top: 0.06rem;
    }
    .el-icon-question {
      margin-top: 0.08rem;
    }
  }

  .st1 {
    width: 100%;
    cursor: pointer;
  }
  .choose {
    background-color: rgba(236, 28, 28, 0.05);
    color: #ec1c1c;
  }

  .t-span {
    position: absolute;
    left: 0;
    top: 0;
    vertical-align: middle;
    display: inline-block;
    text-align: center;
    width: 0.22rem;
    height: 0.22rem;
    line-height: 0.22rem;
    background: rgba(236, 28, 28, 1);
    border-radius: 50%;
    font-size: 0.16rem;
    color: #ffffff;
    font-weight: normal;
    /*background: url(../../assets/images/icon-n1.png) no-repeat center center;*/
    /*background-size: 100% 100%;*/
  }

  .tp-box {
    width: 100%;
    min-height: 3.1rem;
    background: #ffffff;
    box-shadow: 0px 0.03rem 0.12rem rgba(0, 0, 0, 0.06);
    padding: 0.3rem 0.2rem 0.25rem 0.2rem;
    box-sizing: border-box;

    /deep/ .el-radio-group {
      width: 100%;
    }

    /deep/ .el-radio {
      color: #290202;
      width: 100%;
      height: 0.35rem;
      line-height: 0.35rem;
      border-radius: 0.02rem;
      padding: 0 0.1rem;
      box-sizing: border-box;
      margin-bottom: 0.05rem;

      &.is-checked {
        background-color: rgba(236, 28, 28, 0.05);
      }
    }

    /deep/ .el-radio__label {
      .font-elips();
      max-width: 90%;
      display: inline-block;
      vertical-align: top;

      span {
        display: inline-block;
        margin-right: 0.05rem;
        font-size: 0.12rem;
        color: #ec1c1c;
        padding: 1px 0.02rem;
        background: rgba(236, 28, 28, 0.1);
        line-height: initial;
        border-radius: 0.02rem;
      }
    }
  }

  .bc-box {
    color: rgba(41, 2, 2, 0.85);
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    box-sizing: border-box;
    .bc-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-icon-circle-close{
        font-size: 20px;
      }
      .item-sty{
        display: flex;
        align-items: center;
        .icon-sty{
        width: 30px;
        height: 30px;
      }
      }

    }
    /deep/ .el-divider--horizontal{
      margin:10px 0;
    }
    .flex-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      // display: inline-block;
    }

    .drop-one {
      cursor: move;
      font-size: 0.12rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(41, 2, 2, 0.85);
      /*margin: 0 .12rem .15rem .12rem;*/
      width: 24%;
      text-align: center;
      // float: right;
      margin-bottom: 0.17rem;
      &.signer_drop {
        width: 100%;
        border: 1px solid #f2f2f2;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0.05rem;
        span {
          margin: 0;
          flex-shrink: 0;
        }
        .signer_name {
          font-size: 12px;
          padding-left: 0.1rem;
        }
      }

      span {
        display: block;
        width: 0.45rem;
        height: 0.45rem;
        margin: 0 auto 0.05rem auto;
      }
      // p{
      //   width: 0.45rem;
      // }

      &:hover {
        p {
          color: #ec1c1c;
        }

        .icon-txt1 {
          .icon-txt1-on();
        }

        .icon-txt2 {
          .icon-txt2-on();
        }

        .icon-number {
          .icon-number-on();
        }

        .icon-date {
          .icon-date-on();
        }

        .icon-phone {
          .icon-phone-on();
        }

        .icon-idcard {
          .icon-idcard-on();
        }

        .icon-yy {
          .icon-yy-on();
        }

        .icon-ss {
          .icon-ss-on();
        }

        .icon-email {
          .icon-email-on();
        }

        .icon-gz {
          .icon-gz-on();
        }

        .icon-qz {
          .icon-qz-on();
        }

        .icon-qzgz {
          .icon-qzgz-on();
        }
      }
    }
  }

  .bb-box {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 149px;
    background: #ffffff;
    box-shadow: 0rem -0.03rem 0.12rem rgba(0, 0, 0, 0.06);
    opacity: 1;
    padding: 0.32rem 0.28rem;
    box-sizing: border-box;
    width: 100%;
  }
}

.jumpFirst {
  top: -80px;
  bottom: initial;
  pointer-events: initial;
}

.jumpLast {
  top: -25px;
  bottom: initial;
  pointer-events: initial;
}

.danger-btn {
  height: 35px;
  line-height: 35px;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  background-color: #ff0000;
  font-size: 14px;
}

.default-btn {
  flex: auto;
  height: 35px;
  line-height: 35px;
  padding: 0;
  margin: 0;
  color: rgba(41, 2, 2, 0.45);
  border: 1px solid rgba(220, 220, 220, 0.69);
  font-size: 14px;
  margin-left: 0.18rem;
  width: 1.28rem;

  &:first-child {
    margin-left: 0;
  }
}

.com-myDialog {
}
</style>



// WEBPACK FOOTER //
// pages/advancedVersion/setVariable.vue